<template>
  <span class="wa-msg-text"><span v-for="(part, i) in parts" :key="i" :class="{ 'wa-msg-blank': part.blank }">{{ part.text }}</span></span>
</template>

<script>
/**
 * One WhatsApp message's wording, with its [bracketed] blanks highlighted.
 *
 * Used by BOTH practice-facing surfaces - the My Account "WhatsApp messages" card and the
 * Appointment reminders note - so a blank looks the same in both. Presentational only: the text is
 * split by utils/whatsappMessages.js `splitBlanks` and rendered as plain text nodes. There is
 * deliberately NO v-html here: the wording is data from a server and must never become markup.
 */
import { splitBlanks } from '@/utils/whatsappMessages';

export default {
  name: 'WhatsAppMessageText',

  props: {
    text: { type: String, default: '' },
  },

  computed: {
    parts() {
      return splitBlanks(this.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './PatientPayments/tokens';

.wa-msg-text {
  /* Keep the message's own line breaks, wrap everything else - a long word or number must never
     push the card wider than a phone screen. */
  white-space: pre-line;
  overflow-wrap: anywhere;
}

.wa-msg-blank {
  /* Tight padding: punctuation right after a blank ("…time]. Reply") must not look detached. */
  padding: 0 0.12em;
  border-radius: 3px;
  box-decoration-break: clone;
  background: $pp-brand-subtle;
  color: $pp-brand-deep;
  font-weight: 600;
}
</style>
